export default "__VITE_ASSET__dd60abd6__"